import React, { useEffect, useRef, useState } from 'react'
import { CodeEditor, CodeEditorProps } from './code-editor'

/**
 * CodeEditor for json-object-values
 * - user formatting *not* retained
 * - changes are only emitted if the JSON is valid
 *
 * Not to be confused with the classic {@link ../../JsonEditor JsonEditor},
 * which the classic configuration dialogs still use.
 */
export function JsonCodeEditor(props: Omit<CodeEditorProps, "mode" | "value" | "onValueChange"> & {
  value: unknown
  onValueChange: (value: unknown) => void
}) {
  const { value, onValueChange, ...otherProps } = props

  const valueAsString = JSON.stringify(value, null, 4)
  const [ draftValue, setDraftValue ] = useState(valueAsString)
  const lastValueRef = useRef<unknown>()

  useEffect(() => {
    // sync `draftValue` with external changes to `props.value`
    if (lastValueRef.current !== props.value) {
      lastValueRef.current = props.value
      setDraftValue(valueAsString)
    }
  }, [props.value, valueAsString])

  const onChange = (valueString: string) => {
    setDraftValue(valueString)
    try {
      const value = JSON.parse(valueString)
      onValueChange(value)
    } catch (e) {
      // ignore
    }
  }

  return (
    <CodeEditor mode="json"
                value={draftValue}
                onValueChange={onChange}
                {...otherProps} />
  )
}
